<template>
    <div class="notifications-widget">
        <NotificationsIterator :exclude-state="excludeState">
            <template #default="{ noData, hasNewest, items, update, clearAll }">
                <div class="notifications-widget__content">
                    <button
                        v-click-outside="close"
                        type="button"
                        class="notifications-widget__trigger"
                        @click.stop="toggle(update)"
                    >
                        <IconBell />
                    </button>
                    <span v-if="hasNewest" class="notifications-widget__indicator" />
                    <div v-if="showPopup" class="notifications-widget__popup">
                        <template v-if="noData">
                            <p
                                v-t="'crm.notifications.noData'"
                                class="notifications-widget__nodata"
                            />
                        </template>
                        <template v-else>
                            <div class="notifications-widget__list">
                                <NotificationsItem
                                    v-for="item in items"
                                    :key="item.id"
                                    :item="item"
                                    show-date
                                    class="notifications-widget__item"
                                />
                            </div>
                        </template>
                        <Grid class="notifications-widget__footer" :gap="0">
                            <Column>
                                <router-link :to="{ name: routeName }">
                                    {{ $t('crm.notifications.page.trigger') }}
                                </router-link>
                            </Column>
                            <Column>
                                <button
                                    v-if="!noData"
                                    @click.prevent="clearAll"
                                    v-text="$t('crm.notifications.clearAll')"
                                />
                            </Column>
                        </Grid>
                    </div>
                </div>
            </template>
        </NotificationsIterator>
    </div>
</template>

<script>
import { IconBell } from '@speechki-frontend/shared/ui/icons';
import { clickOutside } from '@speechki-frontend/shared/helpers/directives/clickOutside';
import { Grid, Column } from '@speechki-frontend/shared/ui/Grid';
import { NotificationsIterator, NotificationsItem } from '../../components';
import { ITEM_STATES, ROUTE } from '../../utils';

export default {
    name: 'NotificationsWidget',
    components: {
        IconBell,
        Grid,
        Column,
        NotificationsIterator,
        NotificationsItem,
    },
    directives: {
        clickOutside,
    },
    data() {
        return {
            showPopup: false,
            updated: false,
        };
    },
    computed: {
        excludeState() {
            return ITEM_STATES.finite;
        },
        routeName() {
            const { name } = ROUTE;
            return name;
        },
        isCurrentRoute() {
            return this.$route.name === this.routeName;
        },
    },
    methods: {
        toggle(callbackFn = () => {}) {
            const showed = !this.showPopup;
            const { initial, list } = ITEM_STATES;
            const idx = list.findIndex((v) => v === initial);
            const filter = ({ state }) => state === initial;
            const state = ITEM_STATES.list[idx + 1] || null;

            this.showPopup = showed;
            showed && callbackFn({ state, filter });
        },
        open() {
            this.showPopup = true;
        },
        close() {
            this.showPopup = false;
        },
    },
};
</script>

<style lang="scss" src="./NotificationsWidget.scss"></style>
